
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              logo
            </h3>
            <p className="text-gray-300 mb-4">
              Especialistas en módulos plegables y auto armables de alta calidad para todo tipo de proyectos.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Navegación</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('productos')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Productos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('preguntas')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Productos</h4>
            <ul className="space-y-2">
              <li><span className="text-gray-300">Módulos Plegables 6x3m</span></li>
              <li><span className="text-gray-300">Módulos Plegables 6x6m</span></li>
              <li><span className="text-gray-300">Auto Armables 4x4m</span></li>
              <li><span className="text-gray-300">Auto Armables 3x3m</span></li>
              <li><span className="text-gray-300">Auto Armables 6x3m</span></li>
              <li><span className="text-gray-300">Proyectos Personalizados</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-blue-400 mr-2"></i>
                <span className="text-gray-300 text-sm">Carnot 877, San Miguel, Santiago</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-400 mr-2"></i>
                <span className="text-gray-300 text-sm">+56 9 1234 5678</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-400 mr-2"></i>
                <span className="text-gray-300 text-sm">contacto@modulosplegables.cl</span>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line text-blue-400 mr-2 mt-0.5"></i>
                <div className="text-gray-300 text-sm">
                  <div>Lun - Vie: 8:00 - 18:00</div>
                  <div>Sáb: 9:00 - 14:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Módulos Plegables Chile. Todos los derechos reservados.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
